import {Component, signal, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {QuoteOrdersService} from '@coreApiServices';
import {CommonConstants, ROUTES, STORAGE} from '@coreConstant';
import {UserModel} from '@coreModels';
import {ConfirmModalService, LoaderService, SubscribersService, ToastService, TokenStorageService} from '@coreServices';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {SampleOrderComponent} from 'src/app/core/components/product/sidebar/sample-order/sample-order.component';

@Component({
  selector: 'app-modal-sample-order',
  standalone: true,
  imports: [SampleOrderComponent, ReactiveFormsModule],
  templateUrl: './modal-sample-order.component.html',
  styleUrl: './modal-sample-order.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ModalSampleOrderComponent {
  page: any = signal(1);
  cartQuoteForm!: FormGroup;
  sampleOrders: any = [];
  userModel!: UserModel;

  constructor(protected activeModal: NgbActiveModal, private fb: FormBuilder, private loaderService: LoaderService, private confirmModalService: ConfirmModalService, private quoteOrdersService: QuoteOrdersService, private toastService: ToastService, private router: Router, private tokenStorageService: TokenStorageService, private subscriberService: SubscribersService) {
  }

  ngOnInit() {
    this.userModel = this.tokenStorageService.getUser();
    this.cartQuoteForm = this.fb.group({
      project_name: ['', [Validators.required]],
      description: ['']
    });
    this.sampleOrders = this.subscriberService.sampleOrders();
  }

  get f() {
    return this.cartQuoteForm.controls;
  }

  onSubmitQuote() {
    if (this.cartQuoteForm.invalid) {
      this.cartQuoteForm.markAllAsTouched();
      return;
    }
    let text = 'Although we’d love to offer a re-collection service, considerable logistical hurdles make this unfeasible. We’ve been particularly conscious to only apply landfill biodegradable packaging and would kindly request that you thoughtfully repurpose, gift, or dispose of any samples that become redundant.'
    this.confirmModalService.confirm('Premium samples are our gift to you.', text, null, 'Accept')
      .then((confirmed) => {
        if (confirmed) {
          this.loaderService.show();
          let quoteForm = {
            frontend_user_id: this.userModel.id,
            type: CommonConstants.QUOTE_TYPE_SAMPLE_ORDER,
            ...this.cartQuoteForm.value
          }
          this.quoteOrdersService.saveQuoteOrder(quoteForm).subscribe({
            next: (quoteId: any) => {
              let k = 0;
              if (this.sampleOrders.length > 0) {
                this.sampleOrders.forEach((element: any) => {
                  if (element.quantity > 0) {
                    let quoteOrderProduct: any = {
                      quote_id: quoteId,
                      product_id: element.id,
                      quantity: element.quantity,
                    };
                    this.quoteOrdersService.saveQuoteProduct(quoteOrderProduct).subscribe({
                      next: (response: any) => {
                        k++;
                        if (k == this.sampleOrders.length) {
                          this.afterSampleOrderConfirmation(quoteId);
                        }
                      },
                      error: (error: any) => {
                        this.loaderService.hide();
                        this.toastService.showError(error);
                      }
                    });
                  } else {
                    k++;
                    if (k == this.sampleOrders.length) {
                      this.afterSampleOrderConfirmation(quoteId);
                    }
                  }
                });
              }
            },
            error: (error) => {
              this.loaderService.hide();
              this.toastService.showError(error);
            },
          })
        } else {
          this.loaderService.hide();
        }
      });
  }

  afterSampleOrderConfirmation(quoteId: any) {
    this.loaderService.hide();
    this.toastService.showSuccess(CommonConstants.SAMPLE_CREATED_SUCCESS_MESSAGE);
    this.tokenStorageService.removeItemStorage(STORAGE.SAMPLE_ORDER_KEY);
    this.cartQuoteForm.reset();
    this.activeModal?.close();
    this.router.navigate(['/' + ROUTES.ACCOUNT.ROOT + '/' + ROUTES.ACCOUNT.SAMPLES + '/' + quoteId]);
  }
}
